import { useWorkspaceContext } from "@state/workspaceContext";
import { useOrganizationContext } from "@state/organizationContext";
import { useOnboardingStatus } from "./useOnboardingStatus";
import { useTypedFlags } from "./useTypedFlags";

export enum ApplicationView {
    ONBOARDING = "ONBOARDING",
    MAIN = "MAIN",
    PERSONAL_VIEW = "PERSONAL_VIEW",
    ORGANIZATION_VIEW = "ORGANIZATION_VIEW",
}

export function useApplicationView(): ApplicationView {
    const isOnboarded = useOnboardingStatus();
    const { activeWorkspaceId } = useWorkspaceContext();
    const { activeOrganization } = useOrganizationContext();
    const { personalView } = useTypedFlags();

    if (!isOnboarded) {
        return ApplicationView.ONBOARDING;
    }

    if (activeOrganization && !activeWorkspaceId) {
        return ApplicationView.ORGANIZATION_VIEW;
    }

    if (personalView && !activeWorkspaceId) {
        return ApplicationView.PERSONAL_VIEW;
    }

    return ApplicationView.MAIN;
}
